import { getBankIdMode } from "../../utils";
import type { PostRequest } from "../types";

export const startSignQuery = (signingToken: string): PostRequest => ({
	url: "/sign/start",
	method: "POST",
	body: {
		signingToken,
		mode: getBankIdMode() || "PROD",
		provider: "eid",
	},
});

export const signStatusQuery = (bankIdToken: string): PostRequest => ({
	url: "/sign/status",
	method: "POST",
	body: { bankIdToken },
});

export const cancelSignQuery = (bankIdToken: string): PostRequest => ({
	url: "/sign/cancel",
	method: "POST",
	body: { bankIdToken },
});

export const verifySignQuery = (bankIdToken: string): PostRequest => ({
	url: "/sign/verify",
	method: "POST",
	body: { bankIdToken },
});
